<script lang="ts" setup>
import { computed } from 'vue'

interface Props {
    percentage: number
}

const props = defineProps<Props>()

// Calculate stroke-dashoffset for half circle progress
const getStrokeDashoffset = computed(() => {
    const dashArray = 125.6 // Total circumference of the semicircle path
    return dashArray - (dashArray * props.percentage) / 100
})
</script>

<template>
    <div class="circular-progress">
        <svg class="progress-svg" viewBox="0 0 100 50">
            <path class="progress-bg" d="M 10 40 A 40 40 0 0 1 90 40" stroke="#C8C8C8" stroke-width="10" fill="none" />
            <path
                class="progress-fill"
                d="M 10 40 A 40 40 0 0 1 90 40"
                stroke="#002e6c"
                stroke-width="10"
                fill="none"
                stroke-dasharray="125.6"
                :stroke-dashoffset="getStrokeDashoffset"
            />
        </svg>
        <span class="progress-text">{{ Math.round(props.percentage) }}<span class="progress-text-percent">%</span></span>
    </div>
</template>

<style lang="scss" scoped>
.circular-progress {
    position: relative;
    width: 44px;
    height: 37px;
}

.progress-svg {
    width: 100%;
    height: 100%;
}

.progress-bg {
    stroke-linecap: round;
}

.progress-fill {
    stroke-linecap: round;
    transition: stroke-dashoffset 0.3s ease;
}

.progress-text {
    position: absolute;
    z-index: 1;
    bottom: 4px;
    left: 50%;
    color: #002e6c;
    font-size: 12px;
    font-weight: bold;
    transform: translateX(-50%);
}

.progress-text-percent {
    font-size: 10px;
    font-weight: normal;
}
</style>
